import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import "../../Styles/style.css";
import FormVector from "../../../images/formVector.png";
import InputMask from "react-input-mask";
import TimerLoader from "../../../images/timer.gif";
import { Modal, Box, Button } from "@mui/material";
import axios from "axios";
import { baseUrl } from "../../../api/ipconfig";
import SellerBidding from "../../../images/sell-biding.png";
import SubmitIcon from "../../../images/submit-details.png";
import InTouch from "../../../images/will-be-in-touch.png";
import Certified from "../../../images/certified.png";
import GoBidding from "../../../images/go-for-bidding.png";
import SeoMeta from "../../meta";
import PostAd from "../../post-ad-body";
import BiddingPostAd from "../../post-ad-body/bidding";
import Lottie from "lottie-react";
import LockAnimation from "../../../animations/login-continue.json";
import LoginModal from "../../loginModal";
import NumberLogin from "../../loginModal/number";
import InspectionHeaderImage from "../../../images/car-inspection-hero-image.png";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AuthContext } from "../../../context/AuthContext";
import { v4 as uuidv4 } from "uuid";
import FAQsQuestions from "../../FAQs_Questions/FAQsQuestions";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function SellerAppointment() {
  const { user } = React.useContext(AuthContext);
  const history = useHistory();
  const token = localStorage.getItem("token");

  const [fullNameError, setFullNameError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [cities, setCities] = useState(null);
  const [phoneError, setPhoneError] = useState(false);
  const [vehicleTypeError, setVehicleTypeError] = useState(false);
  const [phone, setPhone] = useState(user?.phone || "");
  const [fullName, setFullName] = useState(user?.name || "");
  const [city, setCity] = useState(1);
  const [vehicleType, setVehicleType] = useState("");
  const [modelId, setModelId] = useState("");
  const [YearId, setYearId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [variant, setVariant] = useState("");
  const [variantList, setVariantList] = useState([]);
  const [features, setFeatures] = useState({});
  const [postToken, setPostToken] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [make, setMake] = useState(null);
  const [makeName, setMakeName] = useState(" ");
  const [modelName, setModelName] = useState("");
  const [yearName, setYearName] = useState("");
  const [makeId, setMakeId] = useState("");
  const [modelYear, setModelYear] = useState(null);
  const [getModel, setGetModel] = useState([]);
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const handleSave = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSaved(true);
      setTimeout(() => {
        history.push("/"); // Redirect after 2 seconds
      }, 2000);
    }, 2000); // Simulate API call
  };

  useEffect(() => {
    const generateToken = () => {
      const newToken = uuidv4().replace(/-/g, "").slice(0, 12);
      setPostToken(newToken);
    };

    generateToken();
  }, []);

  const inspectionSubmit = async (e) => {
    e.preventDefault();

    if (
      city !== "" &&
      fullName !== "" &&
      phone !== "" &&
      phone?.length === 11 &&
      makeId !== "" &&
      modelId !== "" &&
      YearId !== "" &&
      vehicleType !== ""
    ) {
      try {
        setIsSubmitting(true);
        const formData = new FormData();

        formData.append("full_name", fullName);
        formData.append("phone", phone);
        formData.append("user_id", user?.id);
        formData.append("cityName", city);
        formData.append("makeName", makeId);
        formData.append("modelName", modelId);
        formData.append("yearName", YearId);
        formData.append("variant_id", variant);
        formData.append(`post_type_id`, 3);
        formData.append(`post_token`, postToken);
        formData.append(`carFeatures`, JSON.stringify(features));

        const response = await axios.post(`${baseUrl}/savepost`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        setIsSubmitting(false);
        setOpenSuccessModal(true);

        setTimeout(() => {
          setOpenSuccessModal(false);
        }, 2000);
        return response?.data;
      } catch (err) {
        console.error(err.response);
      } finally {
        setLoading(false);
      }
    } else {
      handleInputError();
    }
  };


  const faqData = [
    {
      question: "What is a car inspection?",
      answer:
        "A car inspection is a thorough evaluation of a vehicle’s condition, including its mechanical systems, safety features, and overall performance. It aims to identify any issues that may affect the car's safety, reliability, and functionality.",
    },
    {
      question: "In which cities is Famewheels Car Inspection available?",
      answer:
        "Famewheels offers comprehensive car inspections in Karachi. Our services are designed to ensure your vehicle adheres to the highest standards of safety and performance.",
    },
    {
      question: "What is checked during a vehicle inspection?",
      answer:
        "A car inspection typically involves a thorough review of the vehicle's various components and systems, including its engine, transmission, brakes, suspension, and electrical systems. The inspection usually takes between 50 minutes to 1 hour, depending on the extent of the check.",
    },
    {
      question: "What are the benefits of a pre-purchase car inspection?",
      answer:
        "A pre-purchase car inspection helps uncover potential issues and verifies the vehicle's condition before finalizing the purchase. This can prevent unexpected repair costs and ensure you are making an informed decision.",
    },
    {
      question: "What should I do if the inspection report reveals problems?",
      answer:
        "If the inspection report identifies issues, you should discuss repair options or negotiate a price adjustment with the seller. Alternatively, you may need to reconsider proceeding with the purchase if the problems are significant.",
    },
    {
      question: "Does the car inspection report have a validity period?",
      answer:
        "Yes, a car inspection report typically has a validity period, which generally ranges from 30 to 90 days. The condition of the vehicle may change over time, so it’s advisable to act within this period.",
    },
  ];


  useEffect(() => {
    const fetchCity = async () => {
      try {
        const response = await axios.get(`${baseUrl}/cities`);

        setCities(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCity();
  }, []);
  useEffect(() => {
    const fetchMake = async () => {
      try {
        const response = await axios.get(`${baseUrl}/byMake`);

        // console.log("All Make", response.data);
        setMake(response.data);
        // setOptions(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMake();
  }, []);

  // all models api

  useEffect(() => {
    const fetchModel = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/model-by-make?make_id=${makeId}`
        );

        setGetModel(response.data);
        // setOptions(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (makeId) {
      fetchModel();
    }
  }, [makeId]);

  // all years api

  useEffect(() => {
    const fetchYear = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getModelYear`);

        setModelYear(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchYear();
  }, []);
  useEffect(() => {
    const fetchVariant = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getVarientList`, {
          params: {
            modelId: modelId,
            yearId: YearId,
          },
        });

        setVariantList(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (yearName) {
      fetchVariant();
    } else {
      setVariantList([]);
    }
  }, [modelName, yearName]);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getVarient`, {
          params: {
            variant_id: variant,
          },
        });

        //     setVehicleFuel(response.data?.engine_type);
        //     setAssembly(response.data?.assembly);
        //     setCategoryName(response.data?.engine_capacity);
        //     setCassettePlayer(response.data?.cassette_player);
        //     setTransmission(response.data?.transmission);
        //  setHeatedSeats(response.data?.heated_seats);

        setFeatures({
          abs: response.data?.abs,
          air_bags: response.data?.air_bags,
          air_conditioning: response.data?.air_conditioning,
          am_fm_radio: response.data?.am_fm_radio,
          cassette_player: response.data?.cassette_player,
          cd_player: response.data?.cd_player,
          dvd_player: response.data?.dvd_player,
          climate_control: response.data?.climate_control,
          front_camera: response.data?.front_camera,
          front_speakers: response.data?.front_speakers,
          heated_seats: response.data?.heated_seats,
          immobilizer_key: response.data?.immobilizer_key,
          keyless_entry: response.data?.keyless_entry,
          navigation_system: response.data?.navigation_system,
          power_locks: response.data?.power_locks,
          power_mirrors: response.data?.power_mirrors,
          power_steering: response.data?.power_steering,
          power_windows: response.data?.power_windows,
          rear_ac_vents: response.data?.rear_ac_vents,
          rear_camera: response.data?.rear_camera,
          rear_seat_entertainment: response.data?.rear_seat_entertainment,
          rear_speakers: response.data?.rear_speakers,
          steering_switches: response.data?.steering_switches,
          sun_roof: response.data?.sun_roof,
          usb_and_auxillary_cable: response.data?.usb_and_auxillary_cable,
          alloy_rims: response.data?.alloy_rims,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (variant) {
      fetchFeatures();
    } else if (variantList.length === 0) {
      setFeatures({
        abs: false,
        air_bags: false,
        air_conditioning: false,
        am_fm_radio: false,
        cassette_player: false,
        cd_player: false,
        dvd_player: false,
        climate_control: false,
        front_camera: false,
        front_speakers: false,
        heated_seats: false,
        immobilizer_key: false,
        keyless_entry: false,
        navigation_system: false,
        power_locks: false,
        power_mirrors: false,
        power_steering: false,
        power_windows: false,
        rear_ac_vents: false,
        rear_camera: false,
        rear_seat_entertainment: false,
        rear_speakers: false,
        steering_switches: false,
        sun_roof: false,
        usb_and_auxillary_cable: false,
        alloy_rims: false,
      });
    } else {
    }
  }, [modelName, variant, variantList.length, yearName]);

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleLogin = () => {
    // history.push("/login");
    setOpen(true);
  };
  const handleInputError = () => {
    if (fullName === "") {
      setFullNameError(true);
    } else {
      setFullNameError(false);
    }

    if (city === "") {
      setCityError(true);
    } else {
      setCityError(false);
    }

    if (phone === "") {
      setPhoneError(true);
    } else if (phone?.length !== 11) {
      setPhoneError(true);
    } else {
      setPhoneError(false);
    }

    if (vehicleType === "") {
      setVehicleTypeError(true);
    } else if (makeId === "") {
      setVehicleTypeError(true);
    } else if (modelId === "") {
      setVehicleTypeError(true);
    } else if (YearId === "") {
      setVehicleTypeError(true);
    } else {
      setVehicleTypeError(false);
    }
  };

  const handleMakeChange = (e) => {
    const selectedMake = make?.find((item) => item.makeName === e.target.value);
    if (selectedMake) {
      setMakeId(selectedMake.makeId);
    } else {
      setMakeId("");
    }
    setMakeName(e.target.value);
  };

  const handleModelChange = (e) => {
    const selectedModel = getModel.find(
      (item) => item.modelName === e.target.value
    );
    if (selectedModel) {
      setModelId(selectedModel.modelId);
    } else {
      setModelId("");
    }
    setModelName(e.target.value);
  };

  const handleYearChange = (e) => {
    const selectedYear = modelYear.find((item) => item.year === e.target.value);
    if (selectedYear) {
      setYearId(selectedYear.yearId);
    } else {
      setYearId("");
    }
    setYearName(e.target.value);
  };
  const handleConfirmVehicle = () => {
    setIsOpen(false);

    setVehicleType(`${makeName} ${modelName} ${yearName} `);
  };

 

  useEffect(() => {
    if (!window.googletag) {
      console.error("Google Publisher Tag (GPT) is not loaded.");
      return;
    }

    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(() => {
      // Sell Through Live Bidding - Between Ad
      window.googletag
        .defineSlot(
          "/23203048013/SellthroughlivebiddingBetween728x90",
          [728, 90],
          "div-gpt-ad-1743151847783-0"
        )
        .addService(window.googletag.pubads());

      // Sell Through Live Bidding - Mobile Ad
      window.googletag
        .defineSlot(
          "/23203048013/Sell-Through-Live-Bidding/Sell-Through-Live-Bidding-Mobile",
          [
            [320, 100],
            [320, 250],
            [320, 50],
          ],
          "div-gpt-ad-1740123702655-0"
        )
        .addService(window.googletag.pubads());

      // Enable ads
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();

      // Display ads
      window.googletag.display("div-gpt-ad-1743151847783-0"); // Between Ad
      window.googletag.display("div-gpt-ad-1740123702655-0"); // Mobile Ad
    });
  }, []);

  return (
    <>
      <SeoMeta
        title="Sell Through Biddings | FameWheels"
        desc="Explore the new and used cars at the the car auction in Pakistan. Famewheels has provided a platform for live car bidding in which you can bid on your favorite car and also check Famewheels Auction cars in Karachi for reliable and affordable cars."
        url="upcomming"
      />
      {/* submitting modal */}

      <Modal
        open={isSubmitting}
        onClose={() => setIsSubmitting(false)}
        disableAutoFocus={true}
        className="timerModal"
      >
        <Box className="text-center successModal" sx={successModal}>
          <img
            className="modalLoaderImg"
            src={TimerLoader}
            alt="Loading..."
            srcSet=""
          />
        </Box>
      </Modal>
      <Modal open={openSuccessModal} disableAutoFocus={true}>
        <Box className="text-center successModal" sx={successModal}>
          <div className="text-center py-2">
            <h3 style={{ fontSize: 24, fontWeight: "700", color: "#20409a" }}>
              Request received successfully
            </h3>
            <p className="">
              Dear Customer,
              <br />
              Thank you for requesting for bidding, our customer support
              executive will contact you shortly. You can also reach us by call
              or whatsapp on 0300-1113263.
            </p>
            <h2>Have a Good Time!</h2>
          </div>
        </Box>
      </Modal>
      <Modal
        open={isOpen}
        onClose={onClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal position-relative p-4">
          <div className="modalBody_area successBox  px-2 text-center">
            <h3 className="pt-2 mb-5">Select Your Vehicle</h3>

            <div className="container">
              <div className="col-12">
                <div className="mb-3 text-start">
                  <label for="vehicleMake" className="form-label">
                    Select Make
                  </label>
                  <select
                    className="form-select"
                    id="vehicleMake"
                    aria-label="Default select example"
                    required
                    value={makeName}
                    onChange={handleMakeChange}
                  >
                    <option selected value=" ">
                      Select Make
                    </option>
                    {make &&
                      make.map((item) => (
                        <option key={item.makeId} value={item.makeName}>
                          {item.makeName}
                        </option>
                      ))}
                  </select>
                  <div id="CityHelp" className="form-text">
                    Mention your vehicle's make (e.g. Honda)
                  </div>
                </div>
              </div>

              {makeName !== null && (
                <div className="col-12">
                  {makeId && getModel?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleModel" className="form-label">
                        Model
                      </label>
                      <select
                        className="form-select"
                        id="vehicleModel"
                        aria-label="Default select example"
                        required
                        value={modelName}
                        onChange={handleModelChange}
                      >
                        <option selected value=" ">
                          Select {makeName && makeName} Model
                        </option>
                        {getModel &&
                          getModel.map((item) => (
                            <option key={item.modelId} value={item.modelName}>
                              {item.modelName}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention your vehicle's Model (e.g. Civic)
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3 text-start">
                      <label for="vehicleModel" className="form-label">
                        Model
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleModel"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select {makeName && makeName} Model
                        </option>
                      </select>

                      <div id="CityHelp" className="form-text text-danger">
                        Select make first
                      </div>
                    </div>
                  )}
                </div>
              )}
              {modelName && modelName !== "" && (
                <div className="col-12">
                  {makeId && modelName !== " " && modelYear?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleYear" className="form-label">
                        Year
                      </label>
                      <select
                        className="form-select"
                        id="vehicleYear"
                        aria-label="Default select example"
                        required
                        value={yearName}
                        onChange={handleYearChange}
                      >
                        <option selected value=" ">
                          Select Year
                        </option>
                        {modelYear &&
                          modelYear.map((item) => (
                            <option key={item.yearId} value={item.year}>
                              {item.year}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention your vehicle's Year (e.g. 2018)
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3">
                      <label for="vehicleYear" className="form-label">
                        Year
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleYear"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select Year
                        </option>
                      </select>
                      <div id="CityHelp" className="form-text text-danger">
                        Select Model first
                      </div>
                    </div>
                  )}
                </div>
              )}
              {yearName && yearName !== "" && (
                <div className="col-12 text-start">
                  {modelName && yearName !== " " && variantList?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleYear" className="form-label">
                        Variant
                      </label>
                      <select
                        required
                        className="form-select"
                        id="vehicleYear"
                        aria-label="Default select example"
                        value={variant}
                        onChange={(e) => setVariant(e.target.value)}
                      >
                        <option selected value=" ">
                          Select {modelName && modelName} {yearName && yearName}{" "}
                          Variant
                        </option>
                        {variantList &&
                          variantList.map((item) => (
                            <option
                              key={item.featuresId}
                              value={item.featuresId}
                            >
                              {item.featureName}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention {modelName && modelName} {yearName && yearName}{" "}
                        Variant
                      </div>
                    </div>
                  ) : modelName &&
                    yearName !== " " &&
                    variantList?.length === 0 ? (
                    <>
                      <label
                        for="vehicleYear"
                        className="form-label text-start"
                      >
                        Variant
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="varient"
                        aria-describedby="VarientHelp"
                        value={variant}
                        onChange={(e) => setVariant(e.target.value)}
                      />
                      <div id="VarientHelp" className="form-text text-danger">
                        Mention {modelName && modelName} {yearName && yearName}{" "}
                        Varient
                      </div>
                    </>
                  ) : (
                    <div className="mb-3 text-start">
                      <label for="vehicleVariant" className="form-label">
                        Variant
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleVariant"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select Variant
                        </option>
                      </select>
                      <div id="CityHelp" className="form-text text-danger">
                        Select Year first
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <Button
              onClick={handleConfirmVehicle}
              variant="contained"
              className="py-2 px-4 mt-3 color-white fw-700 bgSecondary  text-capitalize"
            >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>
      {/*End submitting modal */}

      <div
        style={{ paddingTop: "11%" }}
        className="container-fluid bgHeroGradient pb-5 "
      >
        <div className="container pb-0 pb-md-4">
          <div className="row align-items-center flex-column-reverse flex-md-row  ">
            <div className="col-lg-7 col-12  text-start ">
              <h2 className="fw-bold color-white fs-2">
                Sell Your Car Through <br />
                <span className="fw-bold fs-1">FameWheels Live Auction</span>
                <p className="fs-6 fw-light mt-4">
                  Join our live auction platform and get the best price for your
                  car quickly and easily!
                  <br /> Provide your details, and our team will contact you to
                  guide you through the process.
                </p>
              </h2>
              <img
                className="topBanner_img img-fluid "
                src={InspectionHeaderImage}
                alt="Sell through live bidding"
              />
            </div>
            <div className="col-lg-5 col-12 mb-5 mb-md-0 ">
              <div className="inspectionFormbox p-4 ">
                <div>
                  <h4 className="text-white fw-bold text-center pb-3 fs-4">
                    Get Started Now!
                  </h4>
                </div>
                <form
                  onBlur={handleInputError}
                  className="row needs-validation"
                  // noValidate
                >
                  <div className="col-12 mb-3">
                    <div>
                      <input
                        type="text"
                        className="form-control"
                        id="inspectionName"
                        placeholder="Enter Full Name"
                        required
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                      />
                    </div>
                    {fullNameError && (
                      <div className="invalid-feedback inputErrorTip ">
                        <i className="fa-solid fa-circle-exclamation me-2"></i>
                        Enter full name
                      </div>
                    )}
                  </div>
                  <div className="col-12 mb-3">
                    <div>
                      <InputMask
                        // mask="03999999999"
                        maskChar={null}
                        type="text"
                        name="inspectionContact"
                        className="form-control"
                        id="inspectionContact"
                        placeholder="Phone No. (03xxxxxxxxx)"
                        required
                        // value={phone}
                        minLength={11}
                        // onBlur={inspectionSubmitonBLur}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                    {phoneError && (
                      <div className="invalid-feedback inputErrorTip ">
                        <i className="fa-solid fa-circle-exclamation me-2"></i>
                        Enter valid phone number
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <select
                        className="form-select"
                        id="inspectionCity"
                        aria-label="Default select example"
                        required
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      >
                        <option value="">Select City</option>
                        {cities &&
                          cities.map((item) => (
                            <option key={item?.cityID} value={item.cityID}>
                              {item.cityName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="inspectionVehicle"
                        aria-describedby="inspectionVehicleHelp"
                        placeholder="Select your car"
                        required
                        value={vehicleType}
                        onClick={() => setIsOpen(true)}
                        readOnly
                      />

                      {vehicleTypeError && (
                        <div className="invalid-feedback inputErrorTip ">
                          <i className="fa-solid fa-circle-exclamation me-2"></i>
                          Select car brand
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      cursor:
                        loading === true || phone?.length < 11
                          ? "not-allowed"
                          : "pointer",
                    }}
                    className="text-center pt-3"
                  >
                    <button
                      type="button"
                      className="btn boxShadow rounded-pill border-0 w-100 inspectionSubmit_btn text-white py-2"
                      style={{
                        backgroundColor:
                          loading || phone.length === 11
                            ? "#b80505"
                            : "#b8050550",
                      }}
                      disabled={loading || phone.length < 11 || saved}
                      onClick={(e) => {
                        if (!user) {
                          e.preventDefault();
                          handleLogin();
                        } else {
                          inspectionSubmit(e);
                        }
                      }}
                    >
                      {loading ? "Saving.." : saved ? "✔ Booked" : "Continue"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <h2>Sell Through Live Bidding</h2>

        {/* Sell Through Live Bidding - Between Ad */}
        <div
          id="div-gpt-ad-1743151847783-0"
          style={{ minWidth: "728px", minHeight: "90px" }}
        ></div>

        {/* Sell Through Live Bidding - Mobile Ad */}
        <div
          id="div-gpt-ad-1740123702655-0"
          className="d-none"
          style={{ minWidth: "320px", minHeight: "50px" }}
        ></div>

        {/* Other content for the page */}
        <div className="memberFormHead">
          <h4 className="pb-4 color-black text-start fs-3 text-capitalize fw-700">
            sell through famewheels live bidding
          </h4>
        </div>

        <div className="row pb-5">
          <div className="col-lg-3 col-6  d-flex justify-content-center align-items-center ">
            <div className="StepperCount">01</div>
            <div className="OurSteppers">
              <img src={SubmitIcon} alt="" srcSet="" />
              <h6 className="text-capitalize ">
                submit vehicle <br /> detail
              </h6>
            </div>
          </div>
          <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center ">
            <div className="StepperCount">02</div>
            <div className="OurSteppers">
              <img src={InTouch} alt="" srcSet="" />
              <h6 className="text-capitalize ">
                We'll be in touch <br /> shortly
              </h6>
            </div>
          </div>
          <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center ">
            <div className="StepperCount">03</div>
            <div className="OurSteppers">
              <img src={Certified} alt="" srcSet="" />
              <h6 className="text-capitalize ">
                car certified from <br /> famewheels
              </h6>
            </div>
          </div>
          <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center ">
            <div className="StepperCount">04</div>
            <div className="OurSteppers">
              <img src={GoBidding} alt="" srcSet="" />
              <h6 className="text-capitalize ">
                ready to live for <br /> bidding
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid grad-bg90 py-4 ">
        <div className="container">
          <div className="row align-items-center ">
            <div className="col-lg-7 col-12">
              <h2 className=" color-white text-start fs-2">
                Sell Your Car Through <br />
                <span className="fw-bold fs-1">Famewheels Live Bidding</span>
              </h2>
            </div>
            <div className="col-lg-5 col-md-12 col-12 text-end p-0">
              <img
                className="topBanner_img img-fluid "
                src={SellerBidding}
                alt="Sell through live bidding"
              />
            </div>
          </div>
        </div>
      </div>

<FAQsQuestions faqData = {faqData}/>

      <Modal
        open={open}
        onClose={onClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal p-3 p-md-4">
          <div className="modalBody_area  px-2 ">
            <NumberLogin />
          </div>
        </Box>
      </Modal>
    </>
  );
}
